// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import WidgetTitle, { WidgetTitleStyles, widgetTitleStyles } from "@bg/App/Components/WidgetTitle";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}
interface CardListHeadingStyles {
    widgetTitle?: WidgetTitleStyles;
}

const styles: CardListHeadingStyles = {
    widgetTitle: {
        title: {
            css: css`
                ${widgetTitleStyles.title?.css}
                line-height: 28px;
                font-size: 24px;
                font-weight: 500;
            `,
        },
    },
};

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return <WidgetTitle extendedStyles={styles.widgetTitle} title={heading} viewAllLink={viewAllUrl} />;
};

export default CardListHeading;
